<div class="p-as-center p-mt-auto p-mb-auto">
    <div class="pages-panel card p-d-flex p-flex-column">
        <div class="pages-header p-px-3 p-py-1">
            <h2>ACCESS DENIED</h2>
        </div>
        <div class="p-mt-3 p-px-6">
            <img src="assets/layout/images/pages/accessdenied.png" alt="" />
        </div>
        <div class="pages-detail p-pb-6">Access to this page is denied.</div>             
    </div>
</div>
